export default {
  pending: 1,
  approved: 2,
  rejected: 3
};



// WEBPACK FOOTER //
// ./src/dictionaries/FileStatuses.js